<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12>
        <v-data-table :headers="rolesListHeaders" :items="roles" item-key="name" hide-actions>
          <template #items="props">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.title[locale] }}</td>
            <td>
              <template v-for="user in getUsersListForRole(props.item)">
                <v-chip small :key="`span-${user.id}`">{{ user['fullname'] }}</v-chip>
                <br :key="`br-${user.id}`"/>
              </template>
            </td>
            <td>{{ props.item.description[locale] }}</td>
            <td class="actions">
              <v-btn flat icon title="Редактировать" color="primary" @click="showRoleFormEdit(props.item)" :disabled="props.item.name === 'manager'">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn flat icon title="Список индикаторов" color="primary" @click="showIndicatorsForRole(props)">
                <v-icon>checklist</v-icon>
              </v-btn>
              <v-btn flat icon title="Список пользователей" color="primary" @click="showUsersForRole(props.item)">
                <v-icon>people</v-icon>
              </v-btn>
              <v-btn v-if="props.item.name !== 'manager'" flat icon title="Удалить" color="error" disabled>
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template v-slot:expand="row">
            <v-container class="elevation-2" fluid>
              <v-layout>
                <v-flex xs12>
                  <v-data-table class="elevation-1" :headers="headersForIndicators" :items="itemsForIndicators" item-key="id" :hide-actions="true" no-data-text="Список индикаторов пуст" :expand="false">
                    <template #items="props">
                      <tr v-if="props.item.type === 'category'">
                        <td>
                          <v-checkbox v-model="allowedIndicators" :value="props.item.code" color="success" hide-details @change="selectIndicatorsInCategory(props.item.code)" />
                        </td>
                        <td class="pl-0">
                          <b>{{ props.item.sequence }}. {{ props.item.title[locale] }}</b>
                        </td>
                      </tr>
                      <tr v-else-if="!props.item.parent">
                        <td>
                          <v-checkbox v-model="allowedIndicators" :value="props.item.id" color="success" hide-details @change="selectChildrenIndicators(props.item.id)" />
                        </td>
                        <td class="pl-3">
                          {{ categoryById(props.item.category).sequence }}.{{ props.item.sequence }}. {{ props.item.title[locale] }}
                        </td>
                      </tr>
                      <tr v-else>
                        <td>
                          <v-checkbox v-model="allowedIndicators" :value="props.item.id" hide-details />
                        </td>
                        <td class="pl-5">
                          {{ props.item.sequence }}) {{ props.item.title[locale] }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 text-xs-right>
                  <v-btn color="info" @click="saveAllowedIndicatorsForRole(row.item)">Сохранить</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-layout mt-3>
      <v-flex xs12 text-xs-right>
        <v-dialog v-model="roleForm.dialog" persistent max-width="600">
          <template v-slot:activator="{ on }">
            <v-btn color="info" v-on="on">Добавить</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Новая роль</span>
            </v-card-title>
            <v-card-text>
              <v-form v-model="roleForm.valid" ref="roleForm">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field label="Код" required v-model="roleForm.values.name" :counter="50" :rules="roleForm.rules.name" :readonly="roleForm.edit"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field label="Название роли (RU)" required v-model="roleForm.values.title_ru" :counter="255" :rules="roleForm.rules.title_ru" />
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field label="Название роли (KZ)" required v-model="roleForm.values.title_kz" :counter="255" :rules="roleForm.rules.title_kz" />
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea label="Описание (RU)" required v-model="roleForm.values.description_ru" :counter="20" :rules="roleForm.rules.description_ru" />
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea label="Описание (KZ)" required v-model="roleForm.values.description_kz" :counter="20" :rules="roleForm.rules.description_kz" />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" flat @click="roleFormClose">Отмена</v-btn>
              <v-btn color="blue darken-1" flat @click="roleFormSave" :loading="roleForm.saving">Сохранить</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>

      <v-dialog v-model="roleUsersList.dialog" persistent lazy :max-width="800">
        <v-card  v-if="roleUsersList.dialog">
          <v-card-title>
            <span class="headline">Список пользователей для роли {{ this.roleUsersList.role.title[locale] }}</span>
          </v-card-title>
          <v-card-text>
            <v-data-table :headers="roleUsersListHeaders" :items="roleUsersList.users" item-key="id" hide-actions :loading="roleUsersList.loading">
              <template #items="{ item: user }">
                <td>{{ `${user.lastname} ${user.firstname} ${user.patronymic}` }}</td>
                <td>{{ user.username }}</td>
                <td>
                  <v-btn flat icon title="Удалить" color="error" @click="dissociateUserFromRole(user, roleUsersList.role)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="roleUsersListClose()">Закрыть</v-btn>
            <v-btn color="blue darken-1" flat @click="roleUsersListAppend()" :loading="roleForm.saving">Добавить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="userAppendToRole.dialog" persistent lazy :max-width="600">
        <v-card v-if="userAppendToRole.dialog">
          <v-card-title>
            <span class="headline">Добавление пользователя в группу роли {{ this.roleUsersList.role.title[locale] }}</span>
          </v-card-title>
          <v-card-text>
            <v-autocomplete v-model="userAppendToRole.user" :items="filteredUsers" item-value="id" item-text="fullname" return-object />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="appendUserToRoleClose()">Закрыть</v-btn>
            <v-btn color="blue darken-1" flat @click="appendUserToRoleDo(userAppendToRole.user, userAppendToRole.role)" :loading="roleForm.saving" :disabled="!userAppendToRole.user">Добавить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import settingsAPI from '@/api/settings'
import { mapState } from 'vuex';
import {sortBySequence} from "@/plugins/helpers";

export default {
  data: () => ({
    roles: [],
    users: [],
    roleForm: {
      dialog: false,
      valid: true,
      saving: false,
      edit: false,
      values: {
        name: '',
        title_ru: '',
        title_kz: '',
        description_ru: '',
        description_kz: ''
      },
      rules: {
        name: [
          v => !!v || 'Обязательное поле',
          v => (v && v.length <= 20) || 'Максимум 20 символов'
        ],
        title_ru: [
          v => !!v || 'Обязательное поле',
          v => (v && v.length <= 100) || 'Максимум 100 символов'
        ],
        title_kz: [
          v => !!v || 'Обязательное поле',
          v => (v && v.length <= 100) || 'Максимум 100 символов'
        ],
        description_ru: [
          v => !!v || 'Обязательное поле',
          v => (v && v.length <= 255) || 'Максимум 255 символов'
        ],
        description_kz: [
          v => !!v || 'Обязательное поле',
          v => (v && v.length <= 255) || 'Максимум 255 символов'
        ]
      }
    },
    roleUsersList: {
      dialog: false,
      loading: true,
      role: null,
      users: []
    },
    userAppendToRole: {
      dialog: false,
      role: null,
      user: null,
    },
    roleIndicatorsList: {
      dialog: false,
      loading: false,
      role: null,
      indicators: [],
    },

    headersForIndicators: [
      {
        text: '',
        sortable: false,
        value: null,
      },
      {
        text: 'Индикатор',
        sortable: false,
        value: null,
      }
    ],
    allowedIndicators: []
  }),
  computed: {
    locale () {
      return this.$i18n.locale
    },
    filteredUsers () {
      if (!this.userAppendToRole.dialog || !this.userAppendToRole.role) {
        return []
      }

      return Object.values(this.users).filter(user => !user.roles.includes(this.userAppendToRole.role.name)).sort((a, b) => a.fullname.localeCompare(b.fullname))
    },
    ...mapState('indicators', {
      categories: (state) => state.categories,
      indicators: (state) => state.indicators
    }),
    itemsForIndicators () {
      let items = []

      Object.values(this.categories).sort(sortBySequence).forEach((category) => {
        items.push({...category, type: 'category'})

        Object.values(this.indicators).filter((indicator) => {
          return indicator.category === category.code
        }).sort(sortBySequence).forEach((indicator) => {
          items.push({...indicator, type: 'indicator'})

          if (indicator.children) {
            Object.values(indicator.children).sort(sortBySequence).forEach((child) => {
              items.push({ ...child, type: 'indicator' })
            })
          }
        })
      })

      return items
    },

    rolesListHeaders () {
      return [
        {
          text: 'Код',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Название',
          align: 'left',
          sortable: true,
          value: `title.${this.locale}`
        },
        {
          text: 'Список пользователей',
          align: 'left',
          sortable: false,
          value: 'users'
        },
        {
          text: 'Описание',
          align: 'left',
          sortable: false,
          value: `description.${this.locale}`
        },
        {
          text: '',
          align: 'right',
          sortable: false,
          value: null
        }
      ]
    },
    roleUsersListHeaders () {
      return [
        {
          text: 'ФИО',
          align: 'left',
          sortable: true,
          value: 'fullname'
        },
        {
          text: 'Логин',
          align: 'left',
          sortable: true,
          value: 'username'
        },
        {
          text: '',
          align: 'right',
          sortable: false,
          value: 'actions'
        }
      ]
    }
  },
  created () {
    this.loadRoles()
    this.loadUsers()
    this.loadIndicators()
  },
  methods: {
    async loadRoles () {
      try {
        const { roles } = await settingsAPI.loadRoles()
        roles.sort((a, b) => a.title[this.locale].localeCompare(b.title[this.locale]))
        this.roles = roles
      } catch (e) {
        // eslint-disable-next-line
        console.error(e)
      }
    },
    async loadUsers () {
      try {
        const { users } = await settingsAPI.loadUsers()
        this.users = users
      } catch (e) {
        // eslint-disable-next-line
        console.error(e)
      }
    },
    async loadIndicators() {
      try {
        await this.$store.dispatch('indicators/getIndicators')
      } catch (e) {
        // eslint-disable-next-line
        console.error(e)
      }
    },

    categoryById (id) {
      return Object.values(this.categories).find((category) => {
        return id === category.code
      })
    },

    selectIndicatorsInCategory(category) {
      const isSelected = this.allowedIndicators.includes(category)

      const indicatorsInCategory = []
      Object.values(this.indicators).filter(indicator => {
        return indicator.category === category
      }).forEach(indicator => {
        indicatorsInCategory.push(indicator.id)
      })

      if (isSelected) {
        this.allowedIndicators = this.allowedIndicators.concat(indicatorsInCategory)
      } else {
        this.allowedIndicators = this.allowedIndicators.filter(indicator => !indicatorsInCategory.includes(indicator))
      }

      indicatorsInCategory.forEach(indicator => {
        this.selectChildrenIndicators(indicator)
      })
    },
    selectChildrenIndicators(parent) {
      const isSelected = this.allowedIndicators.includes(parent)

      const childrenIndicators = []
      const parentIndicator = this.indicators[parent]

      Object.values(parentIndicator.children || {}).forEach(indicator => {
        childrenIndicators.push(indicator.id)
      })

      if (isSelected) {
        this.allowedIndicators = this.allowedIndicators.concat(childrenIndicators)
      } else {
        this.allowedIndicators = this.allowedIndicators.filter(indicator => !childrenIndicators.includes(indicator))
      }
    },

    showRoleFormEdit(role) {
      this.roleForm.values.name = role.name
      this.roleForm.values.title_ru = role.title.ru
      this.roleForm.values.title_kz = role.title.kz
      this.roleForm.values.description_ru = role.description.ru
      this.roleForm.values.description_kz = role.description.kz
      this.roleForm.edit = true
      this.roleForm.dialog = true
    },

    getUsersListForRole(role) {
      return Object.values(this.users).filter(user => user.roles.includes(role.name)).sort((a, b) => a.fullname.localeCompare(b.fullname))
    },

    roleFormClose () {
      this.roleForm.dialog = false
      this.roleForm.edit = false
      this.$refs.roleForm.reset()
    },
    async roleFormSave () {
      if (this.$refs.roleForm.validate()) {
        this.roleForm.saving = true
        try {
          const { role } = await settingsAPI.saveRole(this.roleForm.values, this.roleForm.edit)
          if (!this.roleForm.edit) {
            this.roles.push(role)
          } else {
            let existedRole = this.roles.find(r => r.name === role.name)
            existedRole.title.ru = role.title.ru
            existedRole.title.kz = role.title.kz
            existedRole.description.ru = role.description.ru
            existedRole.description.kz = role.description.kz
          }
          this.$refs.roleForm.reset()
          this.roleForm.saving = false
          this.roleFormClose()
        } catch (e) {
          // eslint-disable-next-line
          console.error(e)
        }
      }
    },

    showIndicatorsForRole(props) {
      props.expanded = true
      this.loadIndicatorsForRole(props.item)
    },
    async loadIndicatorsForRole(role) {
      try {
        const { indicators } = await settingsAPI.loadIndicatorsForRole(role)
        this.allowedIndicators = indicators
      } catch (e) {
        // eslint-disable-next-line
        console.error(e)
      }
    },
    async saveAllowedIndicatorsForRole(role) {
      try {
        await settingsAPI.saveIndicatorsForRole(role, this.allowedIndicators)
      } catch (e) {
        // eslint-disable-next-line
        console.error(e)
      }
    },

    showUsersForRole(role) {
      this.roleUsersList.role = role
      this.roleUsersList.users = [];
      this.roleUsersList.dialog = true
      this.loadUsersForRole(role)
    },
    async loadUsersForRole() {
      try {
        this.roleUsersList.loading = true

        const role = this.roleUsersList.role
        const { users } = await settingsAPI.loadUsersForRole(role)
        this.roleUsersList.users = users
        this.roleUsersList.users.sort((a, b) => a.lastname.localeCompare(b.lastname))
      } catch (e) {
        // eslint-disable-next-line
        console.error(e)
      }
      this.roleUsersList.loading = false
    },
    roleUsersListClose () {
      this.roleUsersList.dialog = false
      this.roleUsersList.role = null
    },
    roleUsersListAppend () {
      try {
        if (this.users.length === 0) {
          this.loadUsers()
        }

        this.userAppendToRole.role = this.roleUsersList.role
        this.userAppendToRole.user = null
        this.userAppendToRole.dialog = true
      } catch (e) {
        // eslint-disable-next-line
        console.error(e)
      }
    },
    appendUserToRoleClose () {
      this.userAppendToRole.dialog = false
    },
    async appendUserToRoleDo (user, role) {
      try {
        await settingsAPI.appendUserToRole(user, role)
        await this.loadUsersForRole()
        this.users[user.id].roles.push(role.name)
        this.appendUserToRoleClose()
      } catch (e) {
        // eslint-disable-next-line
        console.error(e)
      }
    },

    dissociateUserFromRole(user, role) {
      this.$events.$emit('confirm', {
        message: 'Вы действительно хотите удалить роль у пользователя?',
        action: async () => {
          await settingsAPI.dissociateUserFromRole(user, role)
          this.users[user.id].roles = this.users[user.id].roles.filter(r => r !== role.name)
          await this.loadUsersForRole()
        }
      })
    }
  }
}
</script>

<style scoped>
.actions {
  white-space: nowrap;
}
</style>
